<template>
  <div class="section">
    <div v-if="noteTitle" class="flex justify-center mb-10">
      <span class="text-lg leading-5 font-black">{{ noteTitle }}</span>
    </div>
    <div v-if="title || subTitle" class="section__title">
      <h4 v-if="title" class="section__title__text">{{ title }}</h4>
      <slot name="subTitle">
        <span v-if="subTitle">
          {{ subTitle }}
        </span>
      </slot>
    </div>
    <div
      :class="[
        'section__body',
        {
          'section__body--no-title': !title,
        },
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    subTitle: {
      type: String,
      required: false,
      default: () => '',
    },
    noteTitle: {
      type: String,
      default: () => null,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/the-section.scss';
</style>
